import { useNavigate } from 'react-router-dom'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { useMe } from '@/hooks/useMe'
import { Wrench, Database, Mail } from 'lucide-react'

interface ToolItem {
  id: string
  name: string
  description: string
  icon: React.ElementType
  path: string
}

const tools: ToolItem[] = [
  {
    id: 'redis',
    name: 'Redis 快取管理',
    description: '查看與清除 Redis 快取資料，如角色權限快取',
    icon: Database,
    path: '/admin/system-tools/redis',
  },
  {
    id: 'email',
    name: 'Email 發送測試',
    description: '測試系統 Email（Resend）發送功能是否正常運作',
    icon: Mail,
    path: '/admin/system-tools/email',
  },
]

export default function SystemToolsPage() {
  const navigate = useNavigate()
  const { user, isLoading } = useMe()

  // 權限檢查：只有 sys_admin 可以存取
  if (!isLoading && user?.role_type !== 'sys_admin') {
    navigate('/')
    return null
  }

  return (
    <div>
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold tracking-tight flex items-center gap-2">
            <Wrench className="h-8 w-8" />
            系統工具
          </h1>
          <p className="text-muted-foreground mt-2">系統管理員專用的進階管理工具</p>
        </div>
      </div>

      <div className="h-6" />

      {tools.length === 0 ? (
        <Card>
          <CardContent className="pt-6">
            <p className="text-center text-muted-foreground">目前沒有可使用的工具</p>
          </CardContent>
        </Card>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {tools.map((tool) => {
            const Icon = tool.icon
            return (
              <Card
                key={tool.id}
                className="cursor-pointer hover:border-primary transition-colors"
                onClick={() => navigate(tool.path)}
              >
                <CardHeader className="flex flex-row items-center gap-4">
                  <div className="p-3 rounded-xl bg-primary/10">
                    <Icon className="h-8 w-8 text-primary" />
                  </div>
                  <div>
                    <CardTitle className="text-lg">{tool.name}</CardTitle>
                  </div>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-sm">{tool.description}</CardDescription>
                </CardContent>
              </Card>
            )
          })}
        </div>
      )}
    </div>
  )
}
